import { Component, Input } from '@angular/core'
import { SocioeconomicstatusService } from '../../services/socioeconomicstatus/socioeconomicstatus.service'
import { SocioEconomicStatus } from '../../models/socioeconomicstatus.interface'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Filter, QueryGet } from '../../shared/query-types'
import { PAGINATION } from '../../shared/constants'
import { AsyncPipe, CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { SocioeconomicstatusFormComponent } from '../socioeconomicstatus-form/socioeconomicstatus-form.component'
import { MatDialog } from '@angular/material/dialog'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-socioeconomicstatus-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './socioeconomicstatus-list.component.html',
    styleUrl: './socioeconomicstatus-list.component.css',
})
export class SocioeconomicstatusListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    selectedSocioEconomic: SocioEconomicStatus | null = null
    socioeconomicList: SocioEconomicStatus[] = []
    asyncSocioEconomic!: Observable<Pagination<SocioEconomicStatus[]>>
    showColumns: string[] = [
        'acciones',
        'personalData',
        'isHeadOfHousehold',
        'qtyChildren',
        'religion',
        'ownsLand',
        'landArea',
        'isConflictVictim',
        'hasProtectionScheme',
        'civilianStatus',
        'gender',
        'culturaEthnic',
        'sourceIncome',
        'sourceIncomeMethod',
        'disability',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private socioeconomicstatusService: SocioeconomicstatusService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private title: Title
    ) {this.title.setTitle('Estado socioeconómico')}

    fetchSocioEconomic(
        page: number,
        filter: Filter | null = null,
        search = ''
    ) {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncSocioEconomic = this.socioeconomicstatusService
            .allSocioEconomics(params)
            .pipe(
                tap((response) => {
                    this.socioeconomicList = response.results
                    this.socioeconomicstatusService.setSocioEconomics(
                        response.results
                    )
                    this.total = response.count
                }),
                map((res) => {
                    this.loadingService.show(false)
                    return res
                }),
                catchError((error) => {
                    this.loadingService.show(false)
                    this.router.navigate(['home/'])
                    return []
                })
            )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchSocioEconomic(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(socioeconomic: SocioEconomicStatus): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar el registro con ID: ${socioeconomic}?`
        )
        if (!confirmed) return
        this.socioeconomicstatusService
            .deleteSocioEconomic(socioeconomic.id)
            .subscribe({
                next: () => {
                    const successMsg = `Eliminado CORRECTAMENTE!`
                    this.toastr.success(successMsg, 'Exitoso!', {
                        progressBar: true,
                        timeOut: 5000,
                    })
                    this.fetchSocioEconomic(PAGINATION.first_page)
                },
                error: (err) => {
                    this.toastr.error('No se pudo eliminar', 'Error')
                },
            })
    }

    updateSocioEconomic(socioEconomic: SocioEconomicStatus) {
        this.socioeconomicstatusService.setSocioEconomic(socioEconomic)
        const dialogRef = this.dialog.open(SocioeconomicstatusFormComponent, {
            data: { selectedSocioEconomic: this.selectedSocioEconomic },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchSocioEconomic(PAGINATION.first_page)
        })
    }
    create(): void {}
}
